import { cn } from '@anytag/shared-utils';
import { Radio as AnyUIRadio, RadioProps as AnyUIRadioProps } from '@anyui/core';
import { HelpIcon, HelpIconProps } from '../Icon';
import { TextCutter, TextCutterProps } from '../TextCutter';

export interface RadioProps extends AnyUIRadioProps, Pick<TextCutterProps, 'lines'> {
  hint?: HelpIconProps['help'];
}

export const Radio = ({ hint, lines, label, disabled, className, classNames, ...restRadioProps }: RadioProps) => (
  <AnyUIRadio
    disabled={disabled}
    className={cn('radio-wrapper', className)}
    classNames={{
      ...classNames,
      radio: cn({ 'cursor-pointer!': !disabled }, classNames?.radio),
      label: cn('font-normal!', { 'cursor-pointer!': !disabled }, classNames?.label)
    }}
    label={
      label && hint ? (
        <div className="flex items-center gap-1">
          {typeof label === 'string' ? <TextCutter text={label} lines={lines} /> : label}
          {hint && <HelpIcon help={hint} />}
        </div>
      ) : typeof label === 'string' ? (
        <TextCutter text={label} lines={lines} />
      ) : (
        label
      )
    }
    {...restRadioProps}
  />
);
